<template>
	<v-container fill-height fluid class="text-center">
		<v-row no-gutters justify="center" align="center">
			<v-btn
				color="primary"
				fab
				x-large
				@click="overlayClose"
				class="ma-16"
				height="100"
				width="100"
				style="z-index:10"
			>
				<v-icon>close</v-icon>
			</v-btn>
			<template v-if="allowZoom"
				><PuzzleMagnify :loadImage="loadImage" :magZoom="magZoom"
			/></template>
			<template v-else>
				<v-img class="pa-6" :src="getImgUrl(loadImage)" />
			</template>
		</v-row>
	</v-container>
</template>

<script>
import PuzzleMagnify from "@/components/PuzzleMagnify.vue";
export default {
	name: "PuzzleModal",
	components: {
		PuzzleMagnify,
	},
	props: { loadImage: String, allowZoom: Boolean, magZoom: Number },
	methods: {
		overlayClose() {
			this.$emit("overlay-close");
		},
		getImgUrl(src) {
			let images = require.context("../assets/images/", false, /\.png$/);
			if (typeof src !== "undefined") {
				this.avatarImgSrc = src;
			}
			return images("./" + this.avatarImgSrc + ".png");
		},
	},
};
</script>

<style lang="scss" scoped>
.v-btn {
	position: fixed;
	top: 0;
	right: 0;
}
</style>
